__turbopack_context__.v({
  "badge": "qb624a_badge",
  "badge-electricity": "qb624a_badge-electricity",
  "badge-gas": "qb624a_badge-gas",
  "card": "qb624a_card",
  "checkouts-disabled": "qb624a_checkouts-disabled",
  "confirmation-row": "qb624a_confirmation-row",
  "input-grid": "qb624a_input-grid",
  "input-row-2": "qb624a_input-row-2",
  "input-row-3": "qb624a_input-row-3",
  "section": "qb624a_section",
  "teaser-content": "qb624a_teaser-content",
  "teaser-image": "qb624a_teaser-image",
  "unit": "qb624a_unit",
});
